import React from 'react'
import { faFileContract } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './EulaView.styles'
import { isEmpty } from 'lodash'
import { DetailInfo, DetailRow, SectionWrapper } from '@labrav/common'
import { EulaType } from '../../../types/privateOffer'
import { ButtonV4, VerticalDivider } from '@labrav/react-components'

interface EulaViewProps {
  eulaHeading: string
  eulaFiles: string[]
  eulaType?: EulaType
  variant?: 'small' | 'medium'
  secondaryEulaHeading?: string
  secondaryEulaFiles?: string[]
  secondaryEulaType?: EulaType
}

export const EulaView: React.FC<EulaViewProps> = ({
  eulaHeading,
  eulaFiles,
  eulaType,
  secondaryEulaHeading,
  secondaryEulaFiles,
  secondaryEulaType,
  variant = 'medium',
}) => {
  const { classes } = useStyles()

  return (
    <SectionWrapper
      heading="EULA details"
      icon={faFileContract}
      varient={variant}
    >
      <div className={classes.sectionContent}>
        <DetailRow borderBottom={false}>
          <>
            <DetailInfo
              title={eulaHeading}
              value={
                <div className={classes.eulaContent}>
                  {eulaType && (
                    <div className={classes.eulaType}>{eulaType}</div>
                  )}
                  {eulaFiles && eulaFiles.length > 0 && (
                    <EulaFile eulaFiles={eulaFiles} eulaType={eulaType} />
                  )}
                </div>
              }
              keyName="eulaType"
            />
            {secondaryEulaHeading && secondaryEulaFiles && (
              <DetailInfo
                title={secondaryEulaHeading}
                value={
                  <div className={classes.eulaContent}>
                    {secondaryEulaType && (
                      <div className={classes.eulaType}>
                        {secondaryEulaType}
                      </div>
                    )}
                    {secondaryEulaFiles && secondaryEulaFiles.length > 0 ? (
                      <EulaFile
                        eulaFiles={secondaryEulaFiles}
                        eulaType={secondaryEulaType}
                      />
                    ) : (
                      '-'
                    )}
                  </div>
                }
                keyName="eulaType"
              />
            )}
          </>
        </DetailRow>
      </div>
    </SectionWrapper>
  )
}

const EulaFile = ({
  eulaFiles,
  eulaType,
}: {
  eulaFiles: string[]
  eulaType?: EulaType
}) => {
  const { classes } = useStyles()

  const openEula = () => {
    if (!isEmpty(eulaFiles)) {
      eulaFiles?.forEach(file => {
        const newWind = window.open(file, '_blank', 'noopener noreferrer')
        if (newWind) {
          newWind.opener = null
        }
      })
    }
  }

  return (
    <div className={classes.eulaContent}>
      {eulaType && <VerticalDivider height="24px" />}
      <ButtonV4
        variant="tertiary"
        size="medium"
        className={classes.btnLink}
        onClick={openEula}
      >
        View EULA
      </ButtonV4>
    </div>
  )
}
